import React from "react";
import { useNavigate } from "react-router-dom";
import FlashcardCard from "./FlashcardCard";
import { SimpleGrid } from "@mantine/core";

export default function FlashcardGrid(props) {
  const { setId, onDeleteClick, flashcards } = props;
  const navigate = useNavigate();

  const onEditClick = (id, cardId) => {
    navigate(`/cards/${id}/edit/${cardId}`, {
      state: { setId: `${setId}`, cardId: "cardId" },
    });
  };

  return (
    <SimpleGrid style={{ marginTop: "20rem", marginLeft: "2.5rem" }} cols={4}>
      {flashcards.map(({ _id, front, back }, index) => (
        <FlashcardCard
          key={index}
          setId={setId}
          cardId={_id}
          front={front}
          back={back}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
        />
      ))}
    </SimpleGrid>
  );
}
